var codeblock_default = {
  "blockStyleSpacing": "-X0Od",
  "codeBlock": "smaKk -X0Od",
  "renderedInTable": "uOf4m"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
